import { render, staticRenderFns } from "./ApprovedDialog.vue?vue&type=template&id=2be7800a"
import script from "./ApprovedDialog.vue?vue&type=script&lang=js"
export * from "./ApprovedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports